export enum TextComparators {
  Equals = '=',
  Contains = 'con'
}